<template>

  <div class="text-center">
    <form @submit.prevent="submit">

      <div class="custom-file">
        <input @change="loadImages" type="file" class="custom-file-input" required multiple id="customFile">
        <label class="custom-file-label" for="customFile">Choose file</label>
      </div>
      <button class="btn btn-primary rounded-pill w-75 my-2">ثبت</button>

      <div class="col-12" v-for="(item,index) in resizedImages">
        <div class="row align-items-baseline">
          <div class="col-3">
            <img :src="item" class="w-100" alt="">
          </div>
          <div class="col-9" :class="`resized_image_${index}`">

          </div>
        </div>
        <hr>
      </div>


    </form>
  </div>

</template>

<script>
import {toast} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Notification";

export default {
  name: "PaperAnswers",
  props: {
    form: {}
  },
  data() {
    return {
      resizedImages: []
    }
  },
  methods: {
    submit() {


      // Convert each resized image to Blob and append to FormData
      this.resizedImages.forEach((imageDataUrl, index) => {
        const formData = new FormData();
        const blob = this.dataURLToBlob(imageDataUrl);
        formData.append(`image`, blob, `resized_image_${index}.jpg`);
        formData.append(`form_id`, this.form.id);

        // send data
        let req = this.$store.dispatch('Form/paperToAnswer', formData)

        let element = document.querySelector(`.resized_image_${index}`)

        req.then(res => {
          element.innerHTML = 'عملیات با موفقیت انجام شد.'
        }).catch(err => {
          element.innerHTML = 'عملیات انجام نشد'
        })

      });


    },
    loadImages(event) {
      const files = event.target.files;
      Array.from(files).forEach(file => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const img = new Image();
          img.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");

            // Set desired width and height for resizing
            const width = 720;
            const height = 1032;
            canvas.width = width;
            canvas.height = height;

            // Draw the resized image onto the canvas
            ctx.drawImage(img, 0, 0, width, height);

            // Convert canvas to image data (resized image)
            const resizedImage = canvas.toDataURL("image/jpeg", 0.9);

            // Store the resized image data URL
            this.resizedImages.push(resizedImage);
          };
          img.src = e.target.result;
        };
        reader.readAsDataURL(file);
      });
    },
    // Helper method to convert DataURL to Blob
    dataURLToBlob(dataURL) {
      const byteString = atob(dataURL.split(',')[1]);
      const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return new Blob([ab], {type: mimeString});
    }
  }
}
</script>

<style scoped>

</style>